var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('div',{staticClass:"container"},[_c('img',{staticClass:"mx-auto d-block",attrs:{"src":require("@/assets/Covid-19.png"),"alt":"Corvid-19 logo Image"}}),_c('Countries')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }